// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__6+XKw","active":"PageTitle_active__+KyHH"};